module.exports = __webpack_public_path__ + "img/clip_image093.02ddc570.png";